var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "app-footer" }, [
    _c("span", [_vm._v("Lighthouse © 2025 ")]),
    _vm._v(" "),
    _c(
      "span",
      [
        _c(
          "router-link",
          { staticClass: "ml-2", attrs: { to: { path: "/tos" } } },
          [_vm._v("\n        End User Agreement\n      ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-auto" }, [
      _vm._v("Built by "),
      _c("a", { attrs: { href: "http://alliesagainstslavery.org" } }, [
        _vm._v("Allies Against Slavery")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1390
// module chunks = 0